module.exports = "/_next/static/videos/BAG-18c1f6ad732867b0d6142aa9af88ce25.mp4";